define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function riqErrorHandlerServiceImpl(aoflModules) {
  'use strict';

  var riqErrorHandlerService = function riqErrorHandlerService(
    $state,
    aoflLog,
    applicationDebug
  ) {
    var _this = this;
    var storeService = aoflModules.store;

    _this.invalidToken = function invalidToken(_err) {
      /* eslint-disable */
      if (applicationDebug) {
      }
      console.warn('Invalid Token, Redirecting to Login page', _err);
      var hash = window.location.hash.replace('#/', '');
      if (hash.length) {
        localStorage.setItem('deepLinkRedirect', hash);
      }
      throw _err;

      /* eslint-enable */
    };

    _this.invalidProfile = function invalidProfile() {
      var user = storeService.getState().user;
      if (user.fallbackPage.route) {
        $state.go(user.fallbackPage.route);
      }
    };
    /**
     * Check is code exist
     * @function isCodeExist
     * @param {Object} _err - error
     * @return {Boolean} - exist flag
     * */
    _this.isCodeExist = function isCodeExist(_err) {
      return typeof _err === 'object' && 'code' in _err;
    };

    var createDefaultError = function createDefaultError(code, message) {
      return Object.assign(new Error(message), {code: code});
    };

    // eslint-disable-next-line no-unused-vars
    var templateCompiler = function templeCompiler2(msg) {
      var regex = /{([\s\S]+?)}/g;
      return function(payload) {
        return (msg.match(regex) || []).reduce(function(acc, curr) {
          return acc.replace(curr, payload[curr.replace(/{|}/g, '')] || '');
        }, msg);
      };
    };

    _this.getErrorFactory = function getErrorFactory(namespace, errorFacotry) {
      errorFacotry = errorFacotry || createDefaultError;
      return function(code, template, payload) {
        var message =
          '[' +
          (namespace ? namespace : '') +
          ' | ' +
          code +
          '] : ' +
          templateCompiler(template)(payload);
        return errorFacotry(code, message);
      };
    };

    _this.errorHandlers = {
      // eslint-disable-next-line no-unused-vars
      defaultErrorHandler: function(_err) {
        // just lol
      },
      invalidToken: _this.invalidToken,
      210001: _this.invalidToken,
      818116: _this.invalidProfile,
      818118: _this.invalidProfile
    };

    /**
     * Handles error
     * @function handle
     * @param {any} _err - error
     * @return {any} return of the error handler if any
     * */
    _this.handle = function handle(_err) {
      // send user to app login
      aoflLog.error(_err);
      if (_this.isCodeExist(_err)) {
        var errorHandlerFn =
          _this.errorHandlers[_err.code] || _this.defaultErrorHandler;
        return typeof errorHandlerFn === 'function' && errorHandlerFn(_err);
      }
    };
    return _this;
  };

  return riqErrorHandlerService;
});
